<template>

  <!--   -->
  <div class="main-wrapper" ref="root">
    <fullscreen v-model="fullscreen">
    <!--
    <div class="index-container" v-show="false">
      <audio controls="controls" :src="sound" ref="audio"></audio>
    </div>
    -->

    <!---
  ***********************************************************************************
  *******************************    Startup Logo Page    *******************************
  ***********************************************************************************
  v-if="false"
--->
    <div class="index-container" v-show="systemState==0" @click="indexClick">
      <div class="index" @click="indexClick">
        <span><img src="../assets/vehicle/mopiWhite.png" alt class="index-logo" /></span>
      </div>

      <span class="index-txt">画面をタップしてください。</span>
      <!-- <img src="../assets/vehicle/mopi_logo.png" class="mainlogo"> -->
    </div>


    <!---
    ***********************************************************************************
    *******************************    Travel Page    *******************************
    ***********************************************************************************
                  v-if="false"
    --->
    <div class="travelClass" v-show="systemState==5">

      <div class="travelLogoClass">
        <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
      </div>

      <div class="travelLineClass"> {{sourceLocation}} </div>

      <div class="travelCenterClass"> 人数を選んでください </div>

      <div class="travelPassLineClass">
        <div class="travelPassNumberClass" @click="passengerClick(1)"> 1名 </div>
        <div class="travelPassNumberClass" @click="passengerClick(2)"> 2名 </div>
        <div class="travelPassNumberClass" @click="passengerClick(3)"> 3名 </div>
      </div>

      <div class="travelPassLineClass">
        <div class="travelPassNumberClass" @click="passengerClick(4)"> 4名 </div>
        <div class="travelPassNumberClass" @click="passengerClick(5)"> 5名 </div>
        <div class="travelPassNumberClass" @click="passengerClick(6)"> 6名 </div>
      </div>

    </div>


    <!--      Show Time       -->
    <div class="travelClass" v-show="systemState==6">

      <div class="travelLogoClass">
        <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
      </div>
      <div class="travelCenterClass"> 出発時間 </div>

      <div class="travelCenterBigClass"> {{ departTimeText }} </div>

      <div class="travelLineClass" v-show="mergePassenger>0"> {{mergePassengerText}} </div>

      <div class="travelButtonRowClass">
        <div class="travelButtonClass" @click="travelButtonReturnClick"> 戻る </div>
        <div class="travelButtonClass" @click="travelButtonConfirmClick"> 次へ </div>
      </div>
    </div>


    <!--      Show Name       -->
    <div class="travelClass" v-show="systemState==7">

      <div class="travelLogoClass">
        <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
      </div>
      <div class="travelCenterClass"> お名前（ニックネーム）</div>

      <input class="travelInputClass" v-model="travelDepartName"  placeholder="乗客名">

      <div class="travelButtonRowClass">
        <div class="travelButtonClass" @click="travelButtonReturnClick"> 戻る </div>
        <div class="travelButtonClass" @click="travelButtonConfirmClick"> 呼び出す </div>
      </div>
    </div>


    <!--      Show Conclusion       -->
    <div class="travelClass" v-show="systemState==8">
      <div class="travelLogoClass">
        <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
      </div>

      <div class="travelCenterClass"> 以下の内容で車両を呼び出しました </div>

      <div class="travelCenterClass"> {{sourceLocation}} </div>

      <div class="travelConclusionClass"> 予約内容 </div>
      <div class="travelConclusionClass"> {{ travelConclusionTimeText }} </div>
      <div class="travelConclusionClass"> {{ travelConclusionNameText }} </div>
      <div class="travelConclusionClass"> {{ travelConclusionCountText }} </div>


      <div class="travelButtonRowClass">
        <!-- <div class="travelButtonLongClass" @click="travelButtonReturnClick"> キャンセルする </div> -->
        <div class="travelButtonLongClass" @click="travelButtonReturnClick"> はじめの画面にもどる </div>
      </div>
    </div>








    <!---
      ***********************************************************************************
      *******************************    Username Page    *******************************
      ***********************************************************************************
      v-if="false"
    --->
    <!---------------------- Left Side Name Selection State=0 -------------------- v-if="false" -->
    <div class="mainPanel" v-if="systemState==1">
      <div class="mainPanelCenterContent">

        <div class="contentlogo">
          <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
        </div>

        <div class="header_text">{{name_page_header}}</div>
        <div class="content_text">{{name_page_content}}</div>


        <input v-model="passengerName" class="inputstyle" placeholder="乗客名">

        <button
            class="name_input_button"
            @click="name_input_button"
        >次へ
        </button>

        <!--
        <p>Message is: {{ passengerName }}</p>
        <div class="optionbox">
          <select v-model="selected" class="selectstyle">
            <option disabled value="">Please select one</option>
            <option>復原事業情報館</option>
          </select>
        </div>
        <span>Selected: {{ selected }}</span>
        -->

      </div>
    </div>


    <!---
      **************************************************************************************
      *******************************    Destination Page    *******************************
      **************************************************************************************
      v-if="false"
    --->

    <div class="selectionPanel" v-show="systemState==2">
      <div class="selectionpage">

        <div class="contentlogo">
          <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
        </div>

        <div class="mapmap" ref="map" v-show="false"></div>





        <!------------------ Option A --------------->
        <div class="option_text" v-show="select_versionA_text==1">{{source_text}}</div>
        <div class="optionbox" v-show="select_versionA_text==1">
          <select v-model="selectSource" class="selectstyle">
            <option disabled value="">--</option>
            <option>復原事業情報館</option>
          </select>
        </div>

        <div class="option_text" v-show="select_versionA_text==1">{{dest_text}}</div>
        <div class="optionbox" v-show="select_versionA_text==1">
          <select v-model="selectDest" class="selectstyle">
            <option disabled value="">--</option>
            <option>復原事業情報館</option>
          </select>
        </div>



        <!------------------ Option B --------------->
        <div class="header_text" v-show="select_versionA_text==0">{{option_b_text}}</div>
        <div class="header_text" v-show="select_versionA_text==0 && false">{{option_b_time}}</div>
        <div class="header_text" v-show="select_versionA_text==0 && false">{{option_b_passenger}}</div>






        <!------------------ Common --------------->
        <div class="option_text">{{date_text}}</div>
        <div class="optionbox">
          <select v-model="selectDate" class="selectstyle" @change="selectDateChange">
            <option disabled value="">--</option>
            <option v-for="selectDateValue in selectDateValues" :value="selectDateValue.id" :key="selectDateValue.id">{{ selectDateValue.name }}</option>
          </select>
        </div>


        <div class="option_text">{{time_text}}</div>
        <div class="optionbox">
          <select v-model="selectTime" class="selectstyle" @change="selectTimeChange">
            <option disabled value="">{{default_time_text}}</option>
            <option v-for="selectTimeValue in selectTimeValues" :value="selectTimeValue.id" :key="selectTimeValue.id">{{ selectTimeValue.name }}</option>
          </select>
        </div>


        <div class="option_text" >{{next_arrival_time_text}}</div>
        <div class="sub_option_text" >{{passenger_number_text}}</div>




        <div class="option_text">{{passenger_text}}</div>
        <div class="optionbox">
          <select v-model="selectPassenger" class="selectstyle" @change="selectPassengerChange">
            <option disabled value="">{{default_passenger_text}}</option>
            <option v-for="selectPassengerValue in selectPassengerValues" :value="selectPassengerValue.name" :key="selectPassengerValue.id">{{ selectPassengerValue.name }}</option>
          </select>
        </div>

        <div class="upperfooter">
          <button
              class="cancelButton"
              @click="clickCancelButton"
              v-show="false">キャンセル
          </button>

          <button
              class="confirmButton"
              @click="clickConfirmButton"
          >確認
          </button>
        </div>



      </div>
    </div>

    <!---
      ***********************************************************************************
      *******************************    Conclusion Page    *******************************
      ***********************************************************************************
              v-if="false"
    --->
    <div class="conclusionPanel" v-show="systemState==3">
      <div class="conclusionpage">

        <div class="contentlogo">
          <span><img src="../assets/vehicle/colorlogo.png" alt class="content-logo" /></span>
        </div>

        <!--
        <div class="mapmapmap"></div>

        <div class="option_text">{{source_text}}</div>
        <div class="conclusion_text">{{select_source_text}}</div>

        <div class="option_text">{{dest_text}}</div>
        <div class="conclusion_text">{{select_dest_text}}</div>
        -->

        <div class="option_text">{{name_text_confirm}}</div>
        <div class="conclusion_text">{{passengerName}}</div>

        <div class="option_text">{{date_text_confirm}}</div>
        <div class="conclusion_text">{{select_date_text}}</div>

        <div class="option_text">{{time_text_confirm}}</div>
        <div class="conclusion_text">{{select_time_text}}</div>

        <div class="option_text">{{passenger_text}}</div>
        <div class="conclusion_text">{{select_passenger_text}}</div>


        <div class="upperfooter">
          <button
              class="cancelButton"
              @click="clickCancelButton"
          >キャンセル
          </button>

          <button
              class="finalconfirmButton"
              @click="clickFinalConfirmButton"
          >予約の確定
          </button>

        </div>



      </div>
    </div>

    <!---
          ***********************************************************************************
          *******************************    Completed Page    ******************************
          ***********************************************************************************
                  v-if="false"
        --->
    <div class="completionPanel" v-show="systemState==4">
      <div class="completionpage">
        <div class="contentlogo">
          <span><img src="../assets/vehicle/mopiWhiteSmall.png" alt class="content-logo" /></span>
        </div>
      </div>
      <div class="completiontext" @click="clickCompletelButton">
        <div class="complete_text_class">予約が完了しました</div>
      </div>
    </div>














    <!---
      ***********************************************************************************
      *******************************    Left Side Bar    *******************************
      ***********************************************************************************
      v-if="false"
    --->

    <!-----------------------------------------------------------------------
      ------------------------------ Starting -------------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if= "isStart && !isStop && systemState==2 && false">

      <div class="header">
        <div class="sign">
          <mg src="../assets/publicroad/uparrow.png" />
        </div>
      </div>

      <div class="speed_block">
        <div class="speed">{{veh_speed}}</div>
        <div class="unit">km/h</div>
      </div>

      <div class="split">
        <div class="line"></div>
      </div>

      <div class="body">
        <div class="stop_logo">
          <img src="../assets/publicroad/next stop.png" />
        </div>
      </div>

      <div class="station_block">
        <div class="next_station">次の停車スポット</div>
        <div class="station_name">{{next_station_name}}</div>
      </div>


      <div class="footer">
        <button
            class="start"
            @click="clickBtn"
            :style="{backgroundColor: '#F31E22'}"
            >Stop
        </button>
      </div>
    </div>






    <!-----------------------------------------------------------------------
      ------------------------------ Stopping -------------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if="!isStart && !isStop && systemState==2 && false">

      <div class="body">
        <div class="stop_logo">
          <img src="../assets/publicroad/next stop.png" />
        </div>
      </div>

      <div class="station_block">
        <div class="next_station">次の停車スポット</div>
        <!-- <div class="station_name">{{current_station_name}}</div> -->
        <div class="station_name">{{next_station_name}}</div>
      </div>

      <div class="body">
        <div class="car_logo">
          <img src="../assets/publicroad/8seater.png" />
        </div>
      </div>

      <div class="footer">
        <button
            class="start"
            @click="clickBtn"
            :style="{backgroundColor: '#13b49b'}"
            >Start
        </button>
      </div>
    </div>



    <!-----------------------------------------------------------------------
      ------------------------------   Pausing   ----------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if="isStop && systemState==2 && false">

      <div class="body">
        <div class="stopsign_logo">
          <img src="../assets/publicroad/Stopsign.png" />
        </div>
      </div>
      <!--
            <div class="station_block">
              <div class="stop_sign_1">安全を確認して</div>
              <div class="stop_sign_2">Start</div>
              <div class="stop_sign_3">してください</div>
            </div>
      -->


            <div class="footer">
              <button
                  class="start"
                  @click="clickBtn"
                  :style="{backgroundColor: '#13b49b'}"
              >Start
              </button>
            </div>
          </div>


          <!---
            ***********************************************************************************
            *******************************         Map Page    *******************************
            ***********************************************************************************
  --->
    <!--
    <div class="maps" v-show="systemState==5">
      <div class="home" @click="backToLang" v-if="false">
        <img src="../assets/home.png" height="48" width="48" />
      </div>

      <div class="logo" v-if="false">
        <img src="../assets/logo.png" />
      </div>

      <div class="phone" @click="toggleDir" v-if="false">
        <img src="../assets/publicroad/downarrow.png" v-if="isGo"/>
        <img src="../assets/publicroad/uparrow.png" v-if="!isGo"/>
      </div>

      <div class="close" @click="visibleClose = true" v-if="false">
        <img src="../assets/close.png" />
      </div>
    </div>
-->




























    <!---
      ***********************************************************************************
      *******************************          Popup      *******************************
      ***********************************************************************************
    --->

<!--
    <popup v-model="moduleReboot" :text="$t('confirm')" height="28%" @onConfirm="moduleStart">
      <div class="shut">{{$t('moduleStart')}}?</div>
    </popup>

    <popup v-model="visibleClose" :text="$t('confirm')" height="28%" @onConfirm="shutDown">
      <div class="shut">{{$t('shut')}}?</div>
    </popup>

    <popup v-model="websocketConnecting" :text="$t('confirm')" height="28%">
      <div class="shut">{{$t('connecting')}}...</div>
    </popup>
-->
      <!--  -->
    </fullscreen>

  </div>




</template>





<script>
//https://github.com/mirari/vue-fullscreen
// npm install vue-fullscreen
import Vue from "vue";
import VueFullscreen from 'vue-fullscreen';
Vue.use(VueFullscreen)

import { wgs84togcj02 } from "coordtransform";
import moment from "moment";
import Gear from "../components/gearposition";
import Battery from "../components/battery";
import Road from "../components/road";
import Popup from "../components/popup";

//import popDown from '../assets/pop-down.mp3'
//import popUpOn from '../assets/pop-up-on.mp3'
//import popUpOff from '../assets/pop-up-off.mp3'

import { w3cwebsocket } from "websocket";

import { imgs, mapMarker, carUp, carDown, WSURL, BroadcastUrl } from "../utils/indexNara2";

import {route, station, station_point, station_name, stop_pos} from "../utils/routeNara2";

import * as Axios from "axios";

let { sign, auto, manual, start, stop, right, left } = imgs;

export default {
  name: "app",

  components: {
//    Gear,
//    Battery,
//    Road,
//    Popup
  },




  // ********************************************************************************************
  // ***************************                  Data           ********************************
  // ********************************************************************************************
  data() {
    return {
      //sound: popUpOn,

      fullscreen: false,

      CURRENT_SPOT:1,     // *** A
      //CURRENT_SPOT:2,     // *** B

      SPOT_A: 1,
      SPOT_B: 2,
      NAME_A: "朱雀門方面(踏切手前まで)",
      NAME_B: "第一次大極殿院方面",

      orderID:0,
      sourceLocation:"",
      departTimeText:"",
      mergePassenger:0,
      mergePassengerText: "",
      travelConclusionTimeText:"",
      travelConclusionNameText:"",
      travelConclusionCountText:"",

      travelDepartTime:0,
      travelDepartName:"",
      travelDepartCount:0,


      //websocket实例
      client: null,
      BroadClient: null,
      map: null,
      truemap: null,

      //小车车速、电量以及挡位情况
      carInfo: {
        speed: 50,
        batteryLevel: 1,
        gearPosition: "P"
      },

      //当前时间
      time: "",
      //障碍物
      obstacles: [],
      //左转、右转等标志
      signSrc: sign[4],
      //自动/手动驾驶
      isAuto: false,
      timer: null,
      isTempStart: true,
      tempSrc: stop,
      //下一站点信息
      station: {
        name: "",
        time: ""
      },
      //转弯
      isTurn: false,
      turnSrc: "",
      //重连timer
      reconnectionTimer: null,
      roadHeight: 0,
      roadWidth: 0,
      isChina: true,
      //是否展示弹窗
      visible: false,
      stationName: "",
      stationTime: "",
      stationUrl: "",
      //是否展示关机弹窗
      visibleClose: false,
      moduleReboot: false,
      //display connecting info
      websocketConnecting: false,

      //方向盘转换角度
      rotate: 0,




      // ----- Public Road -----
      //底层按钮操作相关变量
      isStart: false,
      isStop: false,    // in STOP sign
      isGo: false,       // Direction Go (top to bottom) or Back (bottom to top)
      current_station_name: "復元事業情報館",
      next_station_name   : "復元事業情報館",
      route_point:0,
      map_route_point:9000,
      loc_lat: 34.69212695816,
      loc_long: 135.79309902602,
      loc_heading:0,
      veh_speed: 29,
      loc_polyline: null, // route
      marker: null,       // 小车标注
      station_margin: 0.0003,
      station_point_margin: 20,


      MAXCUE:72,
      systemState:0,
      cueSize:0,
      objcue: [
        { username: "", passenger: 0},  // 0
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 10
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 20
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 30
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 40
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 50
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 60
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},
        { username: "", passenger: 0},

        { username: "", passenger: 0},  // 70
        { username: "", passenger: 0},
      ],


      passengerName:"",
      selectSource:"",
      selectDest:"",
      selectTime:"",
      selectDate:"",
      selectPassenger:"",

      select_versionA_text:"",
      select_source_text:"",
      select_dest_text:"",
      select_date_text:"",
      select_time_text:"",
      select_passenger_text:"",

      default_Date_text:"--",
      default_time_text:"--:--",
      default_passenger_text:"--:--",

      //option_b_text:" バスは復元事業情報館から出発して大極殿と南門を周遊して復元事業情報館に戻ります。",
      option_b_text:"タクシーは復原事業情報館から出発して大極殿と南門を周遊して復原事業情報館に戻ります。",
      option_b_time:"次の乗車時間 10:00",
      option_b_passenger:"乗車可能人数 3名",

      arrival_time_text: "到着予定時刻: --:--",
      next_arrival_time_text: "直近の予約可能時刻",
      passenger_number_text: "乗車可能人数 6 名",

      space_map: [0, 1.5, 3, 3, 5, 6, 6, 7],

      selectDateValues: [
        { name: "11 月 12 日(土)", id: 1 },
        { name: "11 月 13 日(日)", id: 2 },
      ],


      selectTimeValues: [
                        { name: "9:00am" , id: 1 },
                        { name: "9:30am" , id: 2 },
                        { name: "10:00am", id: 3 },
                        { name: "10:30am", id: 4 },
                        ],


      dateList: [
        { name: "11 月 12 日(土)", id: 1 },
        { name: "11 月 13 日(日)", id: 2 },
      ],

      timeList: [
                { name: "10:00am" , id: 1 },
                { name: "10:10am" , id: 2 },
                { name: "10:20am" , id: 3 },
                { name: "10:30am" , id: 4 },
                { name: "10:40am" , id: 5 },
                { name: "10:50am" , id: 6 },
                { name: "11:00am" , id: 7 },
                { name: "11:10am" , id: 8 },
                { name: "11:20am" , id: 9 },
                { name: "11:30am" , id: 10},
                { name: "11:40am" , id: 11},
                { name: "11:50am" , id: 12},
                { name: "12:00pm" , id: 13},
                { name: "12:10pm" , id: 14},
                { name: "12:20pm" , id: 15},
                { name: "12:30pm" , id: 16},
                { name: "12:40pm" , id: 17},
                { name: "12:50pm" , id: 18},
                { name: "1:00pm" , id: 19},
                { name: "1:10pm" , id: 20},
                { name: "1:20pm" , id: 21},
                { name: "1:30pm" , id: 22},
                { name: "1:40pm" , id: 23},
                { name: "1:50pm" , id: 24},
                { name: "2:00pm" , id: 25},
                { name: "2:10pm" , id: 26},
                { name: "2:20pm" , id: 27},
                { name: "2:30pm" , id: 28},
                { name: "2:40pm" , id: 29},
                { name: "2:50pm" , id: 30},
                { name: "3:00pm" , id: 31},
                { name: "3:10pm" , id: 32},
                { name: "3:20pm" , id: 33},
                { name: "3:30pm" , id: 34},
                { name: "3:40pm" , id: 35},
                { name: "3:50pm" , id: 36},
                { name: "10:00am" , id: 37},
                { name: "10:10am" , id: 38},
                { name: "10:20am" , id: 39},
                { name: "10:30am" , id: 40},
                { name: "10:40am" , id: 41},
                { name: "10:50am" , id: 42},
                { name: "11:00am" , id: 43},
                { name: "11:10am" , id: 44},
                { name: "11:20am" , id: 45 },
                { name: "11:30am" , id: 46},
                { name: "11:40am" , id: 47},
                { name: "11:50am" , id: 48},
                { name: "12:00pm" , id: 49},
                { name: "12:10pm" , id: 50},
                { name: "12:20pm" , id: 51},
                { name: "12:30pm" , id: 52},
                { name: "12:40pm" , id: 53},
                { name: "12:50pm" , id: 54},
                { name: "1:00pm" , id: 55},
                { name: "1:10pm" , id: 56},
                { name: "1:20pm" , id: 57},
                { name: "1:30pm" , id: 58},
                { name: "1:40pm" , id: 59},
                { name: "1:50pm" , id: 60},
                { name: "2:00pm" , id: 61},
                { name: "2:10pm" , id: 62},
                { name: "2:20pm" , id: 63},
                { name: "2:30pm" , id: 64},
                { name: "2:40pm" , id: 65},
                { name: "2:50pm" , id: 66},
                { name: "3:00pm" , id: 67},
                { name: "3:10pm" , id: 68},
                { name: "3:20pm" , id: 69},
                { name: "3:30pm" , id: 70},
                { name: "3:40pm" , id: 71},
                { name: "3:50pm" , id: 72},
     ],


      selectPassengerValues:[
                        { name: "1", id: 1 },
                        { name: "2", id: 2 },
                        { name: "3", id: 3 },
                        { name: "4", id: 4 },
                        { name: "5", id: 5 },
                        { name: "6", id: 6 },
                        { name: "7", id: 7 },
                        ],


      //name_page_header:"平城宮跡ロボットタクシーの予約",
      name_page_header:"自動運転の乗車のご予約",
      name_page_content:"お名前またはニックネームを入力してください",
      //source_text: "乗車スポットを選択",
      //dest_text: "降車スポットを選択",
      //time_text_confirm: "乗車までの時間",
      time_text_confirm: "乗車予定時刻",
      date_text_confirm: "乗車予定日時",
      name_text_confirm: "予約名",
      source_text: "乗車スポット",
      dest_text: "降車スポット",
      //time_text_confirm: "乗車時刻",

      //time_text: "乗車予約時刻 (乗車可能人数)",
      //time_text: "乗車予約時刻",
      time_text: "乗車予定時刻",
      passenger_text:"乗車人数",

      date_text:"乗車予定日時",

      start_date: 12,     // 2022/11/12-13
      first_min: 10*60,   // 10:00
      last_min: 15*60+50, // 15:50
    };
  },



  // ********************************************************************************************
  // ***************************                  Computed       ********************************
  // ********************************************************************************************
  computed: {
    autoOrManual() {
      return this.isAuto ? auto : manual;
    }
  },

  // ********************************************************************************************
  // ***************************                  Created        ********************************
  // ********************************************************************************************
  created() {

    console.log(" ***** Creatrd *****");

    //this.updateTime();
    //this.createWS();
    this.createBroadcast();
  },


  // ********************************************************************************************
  // ***************************                  Mounted        ********************************
  // ********************************************************************************************
  mounted() {

    console.log(" ***** Mounted *****");

    if (this.CURRENT_SPOT==this.SPOT_A)
      this.sourceLocation = this.NAME_A
    else
      this.sourceLocation = this.NAME_B



    // Axios.get("/map_region").then(({ data }) => {
    // let { china_region } = data;

    this.initMap();


    this.isChina = false;
    //let { height, width } = this.$refs.drive.getBoundingClientRect();
    //this.roadHeight = height;
    //this.roadWidth = width;
    // });

    this.default_date_text ="";

    this.destAddress = "";
    this.destName = this.destAddress + "に向かいます";
    this.isCuePickup=false;
    this.isCueDest=false;
    this.freetogo=false;
    this.userNameString = "樣ですか?";

    this.cueSize=0;
    this.systemState=0; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running

        console.log(" ***** cueSize= "+ this.cueSize);
    console.log(" ***** systemState= "+ this.systemState);

  },






  methods: {

    // ********************************************************************************************
    // ***************************              Japan Code         ********************************
    // ********************************************************************************************

    //初始化地图
    initMap() {
      /*
      // let normalMap = this.L.tileLayer.chinaProvider(
      //     this.isChina ? "GaoDe.Normal.Map" : "GoogleCN.Normal.Map",
      //     {
      //         maxZoom: 18,
      //         minZoom: 5
      //     }
      // );
      // let normalMap = this.L.tileLayer.chinaProvider(
      //    "GaoDe.Normal.Map",
      //     {
      //         maxZoom: 18,
      //         minZoom: 5
      //     }
      // );
      let normalMap = this.L.tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }
      );

      //this.truemap = document.querySelector(".mapmap");
      //console.log("InitMap Width : " + this.truemap.clientWidth + " Height : " + this.truemap.clientHeight);

      if (this.systemState==2)
      {
        this.map = this.L.map(document.querySelector(".mapmap"), {
          zoom: 16,
          center: [34.69231126388404, 135.79326182530455],
          layers: [normalMap],
          preferCanvas: true,
          zoomControl: false,
        });
      }
      else
      {
        this.map = this.L.map(document.querySelector(".mapmapmap"), {
          zoom: 16,
          center: [34.69231126388404, 135.79326182530455],
          layers: [normalMap],
          preferCanvas: true,
          zoomControl: false,
        });
      }



      //删除LeafLet右下角logo
      document.querySelector(".leaflet-control-attribution").style.display = "none";

      //this.chk_station()
      this.drawRoute();
      this.drawMarker();

      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 500);
      */
    },



    // ********************************************************************************************
    // ***************************        WebSocket to Engine      ********************************
    // ********************************************************************************************
    //建立websocket连接
    createWS() {
      this.client = new w3cwebsocket(WSURL);
      this.client.onerror = (evt) => {
        console.log("WebSocket Error : " + WSURL);
        //断线自动重连
        this.createWS();
      };
      this.client.onopen = () => {
        console.log("WebSocket Client Connected");
        this.websocketConnecting =false;
      };
      this.client.onclose = (evt) => {
        console.log("WebSocket Closed : " + WSURL);
        //断线自动重连
        this.createWS();
      };
      this.client.onmessage = (evt) => {
        this.tcpCallback(evt.data);
      };
      //每秒刷新当前车辆状态
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestSimulationWorld();
          this.requestRealTimeRoute();
        }
      }, 1000);
    },

    //获取车辆状态信息和环境信息 (100ms per request)
    requestSimulationWorld() {
      this.send({
        type: "RequestSimulationWorld"
      });
    },
    // 获取实时站点信息 (1s per request)
    requestRealTimeRoute() {
      this.send({
        type: "RequestRealTimeNavigation"
      });
    },
    //发送消息
    send(param) {
      this.client.send(JSON.stringify(param));
    },




    // ********************************************************************************************
    // ***************************        WebSocket to Server      ********************************
    // ********************************************************************************************
    createBroadcast(){
      this.BroadClient = new w3cwebsocket(BroadcastUrl);
      this.BroadClient.onerror = (evt) => {
        console.log("Broadcast WebSocket Error : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };
      this.BroadClient.onopen = () => {
        console.log("Broadcast WebSocket Client Connected");
        this.websocketConnecting =false;
      };
      this.BroadClient.onclose = (evt) => {
        console.log("Broadcast WebSocket Closed : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };
      this.BroadClient.onmessage = (evt) => {
        this.tcpCallback(evt.data);
      };
    },

    BroadcastSend(param) {
      console.log("Mobile Send: " + param);
      this.BroadClient.send(param);
    },


    // "type":"HMIStatus","timestamp":1599566463627,"modes":0,"current_mode":0,"enable_log":false,"enable_phone_call":false}
    //tcp回调
    tcpCallback(res)
    {
      //this.BroadcastSend(res);
      console.log("Control Center Received: " + res);

      if (res.indexOf("{") > -1)
      {
        let data = JSON.parse(res);
        console.log(data);


        if (data.type === 'AutoDrivingCar')
        {
          this.veh_speed= data.speed.toFixed(0);
          this.loc_lat= data.latitude;
          this.loc_long= data.longitude;
          this.loc_heading= data.heading;

          console.log("++++++++++++++++++++++++++++++++++++++++++");
          console.log("+++++ lat long heading speed: " + data.latitude +" " +data.longitude +" " +data.heading +" " +data.speed);
          console.log("++++++++++++++++++++++++++++++++++++++++++");

          //this.chk_station()
          this.drawRoute();

        }
        else if (data.type === 'RealTimeNavigation')
        {
          //当前站点信息
          //this.currentPoint = 'You are now at Point ' + this.nextStationName;
        }
        else if (data.type === 'HMIStatus')
        {

          //当前站点信息{"type":"HMIStatus","timestamp":1599494908454,"modes":0}
          if (data.modes === 2 || data.modes === 1 ||data.modes === "PAUSE") {    // 2=Pause, 1=Manual
            this.isStart = false;
          }
          else if (data.modes === 0 || data.modes === "AUTO") {                 // 0=Stop
            this.isStart = true;
          }
          else {                                                                // any other => START
            this.isStart = false;
          }
          //this.chk_station()
          this.drawRoute();
        }
        else if (data.type === "RequestQueueStatus")
        {
          this.objcue[0].username   = data.cueNo0Name;        	// 10:00am
        }

        // **************************************
        // ************** 2023 Nara *************
        // **************************************
        else if (data.type === 'nara2023RequestPickupTime')
        {
          if ((data.orderID === this.orderID) && (data.location == this.CURRENT_SPOT))
          {
            console.log("Time: " + data.time)

            this.travelDepartTime = data.time
            this.departTimeText = (data.time - data.time % 100) / 100 + "時" + data.time % 100 + "分ごろ"

            this.mergePassenger = 0
            this.mergePassenger = data.merge
            this.mergePassengerText = this.mergePassenger + "人なら、より早い時間に出発できます。「戻る」でやり直してください。"
          }
        }

      }
    },







    requestCue()
    {
      this.BroadcastSend(JSON.stringify({type: "RequestQueueStatus"}));
    },

    placeOrder()
    {
      this.BroadcastSend(
                        JSON.stringify({
                        type: "PlaceOrder",
                        name: this.passengerName,
                        pickupTime:this.selectTime-1,
                        passenger:this.selectPassenger,
                        versionA: this.select_versionA_text
                        })
      );

    },

    //[0, 1.5, 3, 3, 5, 6, 6, 7],
    cal_space(time_slot)
    {
      let space=0;
      let i=0;
      let first_passenger=0;


      /*
      for (i=0;i<5;i++)
      {
        space += parseInt(this.objcue[5*time_slot+i].passenger);
      }

      for (i=0;i<5;i++)
      {
        if (parseInt(this.objcue[5*time_slot+i].passenger)==1 && first_passenger==0)
        {
          first_passenger=1;
          space += 1;       // first 1 person team, take passenger seat
        }
        else
        {
          space += this.space_map[parseInt(this.objcue[5*time_slot+i].passenger)]
        }
      }
      space += 0.5;
      */

      //space = this.space_map[parseInt(this.objcue[4*time_slot].passenger)] +
      //        this.space_map[parseInt(this.objcue[4*time_slot+1].passenger)] +
      //        this.space_map[parseInt(this.objcue[4*time_slot+2].passenger)] +
      //        this.space_map[parseInt(this.objcue[4*time_slot+3].passenger)] +
      //        this.space_map[parseInt(this.objcue[4*time_slot+4].passenger)] + 0.5;

      space = parseInt(this.objcue[time_slot].passenger);
      //space = parseInt(space);
      console.log("Occupied Space : " + space);

      //space = 7-space;
      if (space>0)
        space = 0;    // lalaport
      else
        space = 6;

      console.log("Available Space : " + space);
      return space;
    },






    clearDateList()
    {
      this.selectDateValues.splice(0,this.selectDateValues.length);
    },

    createDateList()
    {
      let date = new Date();
      let last_min=0;
      let cur_min =  date.getDate()*24*60 + date.getHours()*60 + date.getMinutes();

      this.clearDateList();

      this.selectDate=0;

      last_min = this.start_date*24*60 + this.last_min;
      if (cur_min<last_min)
        this.selectDateValues.push({name:this.dateList[0].name, id:1 });

      last_min = (this.start_date+1)*24*60 + this.last_min;
      if (cur_min<last_min)
        this.selectDateValues.push({name:this.dateList[1].name, id:2 });

    },




    clearTimeList()
    {
      this.selectTimeValues.splice(0,this.selectTimeValues.length);
    },

    createTimeList()
    {
      let i,j;
      let date = new Date();
      let timeSlot;
      let starttimeSlot, endtimeSlot;
      let space;
      let Aslot=0;
      let Bslot=0;
      let start_min=0;
      let cur_min =  date.getDate()*24*60 + date.getHours()*60 + date.getMinutes();


      if (this.selectDate==1)
      {
        start_min = this.start_date*24*60 + this.first_min;
        if (cur_min < start_min)
        {
          starttimeSlot=0;
          endtimeSlot=35;
        }
        else
        {
          starttimeSlot=parseInt((cur_min-start_min)/10 +1);
          endtimeSlot=35;
        }
      }
      else if (this.selectDate==2)
      {
        start_min = (this.start_date+1)*24*60 + this.first_min;
        if (cur_min < start_min)
        {
          starttimeSlot=36;
          endtimeSlot=71;
        }
        else
        {
          starttimeSlot=35+parseInt((cur_min-start_min)/10 +1);
          endtimeSlot=71;
        }
      }

      console.log("Day: "+date.getDate()+ "   Hour: " +date.getHours()+ "    Min: " +date.getMinutes());
      console.log("Start Slot : " + starttimeSlot + "   End Slot : " + endtimeSlot);

      this.clearTimeList();

      for (i=starttimeSlot;i<=endtimeSlot;i++)
      {
        space = this.cal_space(i);
        if (space>0)
        {
          //this.selectTimeValues.push({name:this.timeList[i].name + " (" + space + "名)", id:i+1 });
          this.selectTimeValues.push({name:this.timeList[i].name, id:i+1 });
          if (Aslot==0)
            this.next_arrival_time_text= "直近の予約可能時刻: " + this.timeList[i].name;
          Aslot++;
        }
      }


      /*
      if (timeSlot<10.5)
        timeSlot=0;
      else
      {
        timeSlot = parseInt(((timeSlot-10.5)/0.5)  +1);
        if (timeSlot==4)
          timeSlot=3;
        if (timeSlot>4)
          timeSlot-=2;
      }
      console.log("Adjusted Slot : " + timeSlot);


      if (timeSlot>=(this.MAXCUE/5))
        timeSlot=0;
      console.log("Hour : " + date.getHours() + "  Min : " + date.getMinutes() + "  Slot : " + timeSlot);
      //this.dest_text = "Hour : " + date.getHours() + "  Min : " + date.getMinutes() + "  Slot : " + timeSlot;    // debug

      this.clearTimeList();
      for (i=0;i<(this.MAXCUE/5);i++)
      {

        // ----- Option A List -----
        if (i>=timeSlot && Aslot<3)
        {
          space = this.cal_space(i);
          //space=0;    // debug
          if (space>0)
          {
            //this.selectTimeValues.push({name:this.timeList[i].name + " (" + space + "名)", id:i+1 });
            this.selectTimeValues.push({name:this.timeList[i].name, id:i+1 });
            if (Aslot==0)
              this.next_arrival_time_text= "直近の予約可能時刻: " + this.timeList[i].name;
            Aslot++;
          }
        }

        // ----- Option B List -----
        if (i>=timeSlot && Bslot<1)
        {
          space = this.cal_space(i);
          //space=0;    // debug
          if (space>0)
          {
            this.option_b_time = "次の乗車時間 " + this.timeList[i].name;
            this.option_b_passenger= "乗車可能人数" + space + "名";
            Bslot++;
          }
        }

      }
      */




      if (Aslot==0)
        this.default_time_text = "予約できる時間がありません";
      else
        this.default_time_text = "--:--";

      if (Bslot==0)
      {
        this.option_b_time = "予約できる時間がありません";
        this.option_b_passenger= "予約できる時間がありません";
      }


    },





    clearPassengerList()
    {
      this.selectPassengerValues.splice(0,this.selectPassengerValues.length);
    },

    createPassengerList()
    {
      let i,j;
      let maxPassenger;
      let space=0;

      this.clearPassengerList();


      //lalaport if (this.select_versionA_text==1)
      //  i=parseInt(this.selectTime)-1;
      //else
      //  i=this.selectTimeValues[0].id-1;
      i=parseInt(this.selectTime)-1;    // get current selected time slot
      //console.log("selectTimeValues[0] : " + i);

      maxPassenger = this.cal_space(i);
      //this.passenger_number_text= "乗車可能人数: " +maxPassenger+ "名";

      if (maxPassenger>0)
      {
        for (j=0;j<7;j++)
        {
          if (j<maxPassenger)
            this.selectPassengerValues.push({name:j+1, id:j+1});
        }
      }
      else
      {
        this.default_passenger_text = "予約できる時間がありません";
      }





    },







    // ********************************************************************************************
    // ***************************           Button Click          ********************************
    // ********************************************************************************************


    indexClick()
    {
      this.fullscreen = true

      this.systemState=5;       // for 2023 Nara2
      //this.requestCue();      // request cue

      this.passengerName="";
    },

    passengerClick(passengerCount)
    {

      // --------------------- Debug---------------------
      /*
      if (passengerCount==5)
      {
        this.CURRENT_SPOT=this.SPOT_A
        this.sourceLocation = this.NAME_A
      }
      else if (passengerCount==6)
      {
        this.CURRENT_SPOT=this.SPOT_B
        this.sourceLocation = this.NAME_B
      }
      */
      // ---------------------

      this.orderID = Date.now()%1000000;

      this.BroadcastSend(
          JSON.stringify({
            type: "nara2023RequestPickupTime",
            location: this.CURRENT_SPOT,
            count: passengerCount,
            orderID: this.orderID,
          })
      );
      this.travelDepartCount = passengerCount
      this.systemState = 6

      console.log("Count: " + passengerCount+ "  ID: "+this.orderID)
    },

    travelButtonReturnClick()
    {
      this.systemState = 5
    },

    travelButtonConfirmClick()
    {
      if (this.systemState == 6)
        this.systemState = 7
      else if (this.systemState == 7)
      {
        if (this.travelDepartName === "")
          return

        this.travelConclusionTimeText = "出発時間： " + (this.travelDepartTime-this.travelDepartTime%100)/100+"時" + this.travelDepartTime%100+"分ごろ"
        this.travelConclusionNameText = "お名前: " + this.travelDepartName
        this.travelConclusionCountText = "人数: " + this.travelDepartCount
        this.systemState = 8

        this.BroadcastSend(
            JSON.stringify({
              type: "nara2023SetPickupTime",
              location: this.CURRENT_SPOT,
              time: this.travelDepartTime,
              name: this.travelDepartName,
              passenger: this.travelDepartCount,
            })
        );
      }
    },






















    name_input_button()
    {
      console.log("***** Username : " + this.passengerName);

      if (this.passengerName=="")
        return;

      this.selectSource="";
      this.selectDest="";
      this.selectTime="";
      this.selectPassenger="";

      this.systemState=2;
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.marker = null;
      }
      this.initMap();

      /*
      if(Math.floor(Math.random() * 10) < 5)
      //if(Math.floor(Math.random() * 10) < 0)  // debug
      {
        this.select_versionA_text =1;
        this.createTimeList();
        this.clearPassengerList();
      }
      else
      {
        this.select_versionA_text =0;
        this.createTimeList();
        this.clearPassengerList();
        //this.createPassengerList();
      }
      */
      this.select_versionA_text =2;   // lalaport no need source and destination
      //this.createTimeList();
      this.createDateList();
      this.clearTimeList();
      this.clearPassengerList();


    },

    clickCancelButton()
    {
      this.systemState=0;
    },


    clickConfirmButton()
    {
      /*
      if (this.select_versionA_text==1)
      {
        if (this.selectSource=="" || this.selectDest=="" || this.selectTime=="" || this.selectPassenger=="")
        {
          return;
        }
      }
      else if (this.selectPassenger=="")
        return;

      if (this.select_versionA_text==0)
      {
        this.selectSource = "復原事業情報館";
        this.selectDest = "復原事業情報館";
        this.selectTime = this.selectTimeValues[0].id;
      }
      */

      this.select_source_text=this.selectSource;
      this.select_dest_text=this.selectDest;
      this.select_date_text=this.dateList[parseInt(this.selectDate)-1].name;
      this.select_time_text=this.timeList[parseInt(this.selectTime)-1].name;
      this.select_passenger_text=this.selectPassenger;

      this.systemState=3;

      /*
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.marker = null;
      }
      this.initMap();
      */
      //this.placeOrder();
    },

    clickFinalConfirmButton()
    {
      this.systemState=4;
      this.placeOrder();
      //this.systemState=0;
      //this.placeOrder();
    },

    clickCompletelButton()
    {
      this.systemState=0;
    },


    selectDateChange(e) {
      console.log("***** Selected Date : " + e.target.value + "   " + this.selectDate);
      this.createTimeList();
    },


    selectTimeChange(e)
    {
      console.log("***** Selected Time : " + e.target.value + "   " +this.selectTime);
      this.createPassengerList();
      //this.$refs.map.refresh();

      this.arrival_time_text="到着予定時刻: " + this.timeList[parseInt(this.selectTime)-1].name;
      /*
      if (parseInt(this.selectTime)<=6)
        this.next_arrival_time_text= "次回の到着予定時刻: " + this.timeList[parseInt(this.selectTime)+1].name;
      else
        this.next_arrival_time_text= "次回の到着予定時刻: --:--";
      */
    },


    selectPassengerChange(e)
    {
      console.log("***** Selected Passenger : " + e.target.value + "   " + this.selectPassenger);
      //this.$refs.map.refresh();
    },













    //点击开始/结束按钮
    clickBtn() {

        if (this.isStart)
          this.BroadcastSend("Mopi2Stop");
        else
          this.BroadcastSend("Mopi2Start");

      //先根据指令停车开车
      //this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": this.isStart ? 'PAUSE' : 'AUTO'});
      //this.isStart = !this.isStart;


      /*
      if (!this.isArrivedNext) {
        this.isPoint = true;
        this.currentPoint = 'You are now moving to Point ' + this.nextStationName;
      } else {
        this.isPoint = false;
        this.currentPoint = 'You are now at Point ' + this.nextStationName;
      }
      */
    },





    clickBtnNameYes()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },

    clickBtnNameNo()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },






    // ***************************************************************************************************
    // **************************    Check whether it stop at proper station    **************************
    // ***************************************************************************************************
    chk_station(){
      let location=[this.loc_lat, this.loc_long];
      let point_checked= false;

      // ----- if Stopped, chk within station range or StopSign range -----
      // ----- update isGo, isStop, route_point, current_station_name, next_station_name
      if (!this.isStart)
      {
        if (this.chk_point(station[0], location, this.station_margin)){   // station 0 -> go up
          this.isGo=false;     // mean go up next
          this.isStop=false;
          this.route_point=station_point[0];
          this.current_station_name=station_name[0];
          this.next_station_name=station_name[1];
          point_checked=true;
        } else if (this.chk_point(station[1], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[1];
          this.current_station_name=station_name[1];
          if (this.isGo)
            this.next_station_name=station_name[0];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[2], location, this.station_margin)){
          this.isGo=true;     // will go down next
          this.isStop=false;
          this.route_point=station_point[2];
          this.current_station_name=station_name[2];    // in top
          this.next_station_name=station_name[1];
          point_checked=true;
        }
        /*
        else if (this.chk_point(station[3], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[3];
          this.current_station_name=station_name[3];
          if (this.isGo)
            this.next_station_name=station_name[4];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[4], location, this.station_margin)){
          this.isGo=false;     // must go back
          this.isStop=false;
          this.route_point=station_point[4];
          this.current_station_name=station_name[4];
          this.next_station_name=station_name[3];
          point_checked=true;
        } else if (this.chk_point(stop_pos, location, this.station_margin)){
          this.isStop=true;
          this.route_point=58;
          if (this.isGo) {
            this.current_station_name = station_name[0];
            this.next_station_name = station_name[1];
          }
          else{
            this.current_station_name=station_name[1];
            this.next_station_name=station_name[0];
          }
          point_checked=true;
        }
        */
      }

      // ----- if Running, chk within point range -----
      // ----- update route_point
      if (point_checked==false)
      {
         let i;
         for (i=0;i<route.length;i++){
           if (this.chk_point(route[i],location, this.station_margin)) {
             this.route_point = i;
             this.isStop = false;
             i = 1000;
           }
         }

         //if (i==1001)   // route point updated
         if (i==9999)     // disabled - never use
         {
           let point_margin;

           // Station 0<->1
           point_margin=(station_point[1]-station_point[0])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[0]+point_margin)) && (this.route_point<(station_point[1]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[0];
               this.next_station_name   =station_name[1];
             } else {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[0];
             }
           }

           // Station 1<->2
           point_margin=(station_point[2]-station_point[1])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[1]+point_margin)) && (this.route_point<(station_point[2]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[2];
             } else {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[1];
             }
           }
           /*
           // Station 2<->3
           point_margin=(station_point[3]-station_point[2])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[2]+point_margin)) && (this.route_point<(station_point[3]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[3];
             } else {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[2];
             }
           }
           // Station 3<->4
           point_margin=(station_point[4]-station_point[3])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[3]+point_margin)) && (this.route_point<(station_point[4]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[4];
             } else {
               this.current_station_name=station_name[4];
               this.next_station_name   =station_name[3];
             }
           }
           */

         }


      }
      console.log("**********");
      console.log("***** Route Point : " + this.route_point);
      console.log("**********");
    },

    chk_point(point, loc, margin)
    {
      //console.log("????? Margin : " + margin);
      //console.log("????? Check Point : " + point[0] +" " +point[1]);
      //console.log("????? Loc   Point : " + loc[0] +" " +loc[1]);

      if (loc[0]>(point[0]+margin) || loc[0]<(point[0]-margin)){
        return false;
      }
      if (loc[1]>(point[1]+margin) || loc[1]<(point[1]-margin)){
        return false;
      }
      return true;
    },


    drawRoute()
    {
      //if (this.route_point == this.map_route_point)
      //  return;
      //this.map_route_point = this.route_point;

      let i;
      let points = [];
      for (i = 0; i<route.length; i++){    // from start or route points
        points.push(route[i]);
        //console.log("Points : " + points[i]);
      }

      // ---------- Draw Route Line ---------
      if (this.loc_polyline!=null){
        this.map.removeLayer(this.loc_polyline);
      }

      {
        this.loc_polyline = this.L.polyline(points, {
          color: "#13b49b",
          weight: 6
        }).addTo(this.map);
      }

      // ---------- Update Car Marker ---------
      let position= [this.loc_lat, this.loc_long];
      let heading= this.loc_heading;
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }// else
      {
        this.marker = this.drawCar(position, heading);
      }




      /*
      if (this.isGo){     // top to bottom?
        for (i=(route.length-1); i>=this.map_route_point; i--){
          points.push(route[i]);
        }
      } else{             // bottom to top
        for (i = 0; i<=this.map_route_point; i++){    // from start or route points
          points.push(route[i]);
        }
      }
      */



      //this.map.fitBounds(this.loc_polyline.getBounds());
      //this.map.panTo(station[1], 16);

    },



    drawCar(point, heading)
    {
      let icon = this.L.icon({
        iconUrl: carUp,
        iconSize: [31, 44]
      });
      return this.L.marker(point, {
        icon,
        zIndexOffset: 100,
        //rotationAngle: heading,
        rotationOrigin: "center center"
      }).addTo(this.map);

      /*
      //let icon = this.L.icon({
      //  iconUrl: mapMarker,
      //  iconSize: [40, 40]
      //});
      if (this.isGo)
      {
        let icon = this.L.icon({
          iconUrl: carDown,
          iconSize: [31, 44]
        });
        return this.L.marker(point, {
          icon,
          zIndexOffset: 100,
          //rotationAngle: heading,
          rotationOrigin: "center center"
        }).addTo(this.map);
      }
      else
      {
        let icon = this.L.icon({
          iconUrl: carUp,
          iconSize: [31, 44]
        });
        return this.L.marker(point, {
          icon,
          zIndexOffset: 100,
          //rotationAngle: heading,
          rotationOrigin: "center center"
        }).addTo(this.map);
      }
      */

    },

    //更新车辆位置
    updateCarPosition(position, heading) {
      //this.map.panTo(position, 18);

      this.marker.slideTo(position, {
        //rotationAngle: heading,
        duration: 20,
        rotationOrigin: "center center"
      });
    },


    //根据标注点位画标注
    drawMarker() {
      /*
      for (let marker of markers) {
        this.L.marker(marker.lng)
          .addTo(this.map)
          .addTo(this.map)
          .on("click", () => {
            marker.id !== undefined &&
              this.client &&
              this.client.readyState === 1 &&
              this.client.send(
                JSON.stringify({
                  type: "RequestStationInfo",
                  station_id: marker.id,
                  lang: this.$i18n.locale
                })
              );
          });
      }
      */

      /*
        // Creating a Marker
        let markerOptions = {
          title: "MyLocation",
          clickable: true,
          draggable: true
        }
        */


      // Icon options
      let iconOptions = {
        iconUrl: '../assets/publicroad/ssdot.png',
        //iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        //iconSize: [102, 102]
        iconSize: [10, 10],
      }

      // Creating a custom icon
      let customIcon = this.L.icon(iconOptions);

      let i;
      for (i = 0; i < station_name.length; i++)
      {
        // Creating Marker Options
        let markerOptions = {
          title: station_name[i],
          clickable: true,
          draggable: true,
          //icon: customIcon
          //icon: iconOptions
        }
        // Creating a Marker
        let marker = this.L.marker(station[i], markerOptions);

        // Adding popup to the marker
        marker.bindPopup(station_name[i]).openPopup();

        // Adding marker to the map
        marker.addTo(this.map);

      }

    },

    toggleDir() {
      this.isGo = !this.isGo;
      //this.route_point+=50;
      //this.loc_lat = 35.1628012;
      //this.loc_long = 137.8680675;
      //this.isStop = !this.isStop;

      this.chk_station()
      this.drawRoute();
    },






























    // ********************************************************************************************
    // ***************************                  OLD Code       ********************************
    // ********************************************************************************************

    // 返回lang页选择语言
    backToLang() {
      //this.isStart = !this.isStart;
      //this.drawRouter(route);
      //this.drawMarker();
      //this.$router.push({
      //  path: "/"
      //});
    },

    //用于时间更新
    updateTime() {
      this.timer = setInterval(() => {
        this.time = moment().format("LT");
      }, 1000);
    },

    //路径以及标注数据适配
    formatRoutes(routes) {
      if (!routes) return;

      let points = [], //路径点
        markers = []; //标注点

      let startPosition = wgs84togcj02(
        routes.startPoint.longitude,
        routes.startPoint.latitude
      ).reverse();
      points.push(startPosition);

      if (routes.startPoint.isStation) {
        markers.push({
          lng: startPosition,
          id: routes.startPoint.stationId
        });
      }

      for (let point of routes.points) {
        let { latitude, longitude, isStation, stationId } = point;

        let position = wgs84togcj02(longitude, latitude).reverse();
        points.push(position);

        isStation &&
          markers.push({
            lng: position,
            id: stationId
          });
      }

      let endPosition = wgs84togcj02(
        routes.endPoint.longitude,
        routes.endPoint.latitude
      ).reverse();
      points.push(endPosition);

      if (routes.endPoint.isStation) {
        markers.push({
          lng: endPosition,
          id: routes.endPoint.stationId
        });
      }

      return {
        points,
        markers
      };
    },

    async drawRoutesAndMarkers(routes) {
      let { points, markers } = this.formatRoutes(routes);

      //根据坐标点画线路图
      this.drawRouter(points);

      //根据标注点画标注图
      this.drawMarker(markers);
    },

    //根据坐标点位画路线
    drawRouter(points) {
      let polyline = this.L.polyline(points, {
        //color: "#bc4be5",
        color: "#13b49b",
        weight: 5
      }).addTo(this.map);

      this.map.fitBounds(polyline.getBounds());
    },












    //建立websocket连接
    createWSOri(url, looptTime) {
      let client = new w3cwebsocket(url);

      client.onerror = () => {
        console.error("Connection Error");
      };

      client.onclose = () => {
        this.reconnection(true);
        this.websocketConnecting =true;
        console.log("Client Closed");
      };

      return client;
    },





    //websocket处理函数
    processWS(url, looptTime = 100)
    {
      this.client = this.createWSOri(url, looptTime);

      this.client.onopen = () => {
        console.log("WebSocket Client Connected");
        this.websocketConnecting =false;
      };


      // Request simulation world every 100ms.
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestSimulationWorld();
        }
      }, 1000);

      // Request RealTimeRoute every 1000ms.
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestRealTimeRoute();
        }
      }, 1000);




      // ----------------------------------------------
      // --------------- Socket Message ---------------
      // ----------------------------------------------
      this.client.onmessage = async ({ data }) => {
        if (data) {
          let message = null;
          try {
            message = JSON.parse(data);
          } catch (error) {
            console.warn(`Failed to parse string ${data}.`);
            return;
          }

          if (message.type === "RoutePath") {
            await this.drawRoutesAndMarkers(message);
          } else if (message.type === "AutoDrivingCar") {
            let {
              battery_level,
              gear_position,
              heading,
              latitude,
              longitude,
              speed,
              vehicle_status,
              steer_angle
            } = message;

            this.carInfo = {
              speed: speed ? speed.toFixed(0) : 0,
              batteryLevel: parseInt(battery_level * 100),
              gearPosition: gear_position.substr(0, 1)
            };

            if (heading && latitude && longitude) {
              let position = wgs84togcj02(longitude, latitude).reverse();

              if (this.marker) {
                this.updateCarPosition(position, heading);
              } else {
                this.marker = this.drawCar(position, heading);
              }
            }

            if (vehicle_status !== undefined) {
              this.isAuto = vehicle_status == 5 ? false : true;
              this.signSrc = sign[vehicle_status - 1];

              if (vehicle_status == 0) {
                this.signSrc = sign[4];
              }

              if (vehicle_status == 1) {
                this.turnSrc = left;
                this.isTurn = true;
              } else if (vehicle_status == 2) {
                this.turnSrc = right;
                this.isTurn = true;
              } else {
                this.isTurn = false;
              }
            }

            if (steer_angle) {
              this.rotate = steer_angle;
            } else {
              this.rotate = 0;
            }
          } else if (message.type === "SimulationWorld") {
            let { object } = message;

            Array.isArray(object) && (this.obstacles = object);
          } else if (message.type === "RealTimeNavigation") {
            let { next_station_name, next_station_timing } = message;

            this.station = {
              name: next_station_name,
              time: next_station_timing
            };
          } else if (message.type === "pong") {
            //心跳包
            this.client &&
              this.client.readyState === 1 &&
              this.client.send(
                JSON.stringify({
                  type: "ping"
                })
              );
          } else if (message.type === "HMIStatus") {
            let { current_mode } = message;

            if (current_mode == 0) {
              this.isAuto = true;
              this.isStart = true;
            } else if (current_mode == 1 || current_mode == 2) {
              this.isAuto = false;
              this.isStart = false;
            }
          } else if (message.type === "StationInfo") {
            this.visible = true;
            this.stationName = message.station_name;
            this.stationTime = message.station_timing;
            this.stationUrl = message.station_url;
          }
        }
      };
    },



    /*
    requestSimulationWorld() {
      this.client.send(
        JSON.stringify({
          type: "RequestSimulationWorld"
          //  planning : requestPlanningData,
        })
      );
    },
    requestRealTimeRoute() {
      this.client.send(
        JSON.stringify({
          type: "RequestRealTimeNavigation"
        })
      );
    },
    */



    //websocket心跳机制
    reconnection(flag = false) {
      if (flag) {
        if (this.reconnectionTimer) {
          return false;
        }

        this.reconnectionTimer = setTimeout(() => {
          console.log("reconnection!!!");

          if (this.map) {
            this.map.remove();
            this.map = null;
            this.marker = null;
          }

          this.initMap();
          this.processWS(WSURL);

          clearTimeout(this.reconnectionTimer);
          this.reconnectionTimer = null;
        //}, 5000);
        }, 1000000);    // Patrick debug
      }
    },




  },





  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }



};

</script>





















<style scoped>


.main-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}



/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------        Index     -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.index-container {
  /* */
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #13b49b;
  position: absolute;
  font-size: 60px;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.index {
  width: 80%;
  height: 20%;
  left: 0;
  right: 0;
  margin-top: auto;
  text-align: center;
}

.index-logo{
  width: 240px;
  height: 64px;
  margin-bottom: 0px;
}

.index-txt{
  font-size:18px;
  margin-top: 0px;
  margin-left: 0px;
  color: #ffffff;
  text-align: center;
  padding:0px;
  border: 0;
  margin-bottom: 120px;
  margin-top: auto;
}

.mainlogo{
  width: 195px;
  height: 67px;
  position:fixed;
  bottom:50px;
  left:50%;
  margin-left: -100px;
}


.travelClass{
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
}

.travelLogoClass {
  display: flex;
  flex-direction: row;
  height: 15%;
  justify-content: center;
}

.travelLineClass{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 5%;

  margin-left: 20px;
  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelConclusionClass{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 5%;
  width: 80%;
  margin-left: 10%;
  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelCenterClass {
  display: flex;
  flex-direction: row;
  height: 5%;
  justify-content: center;

  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelCenterBigClass {
  display: flex;
  flex-direction: row;
  height: 20%;
  justify-content: center;

  font-size:35px;
  font-weight: bold;
  color: #000000;
}


.travelPassLineClass{
  display: flex;
  flex-direction: row;
  height: 120px;
  justify-content: center;

  font-size:20px;
  font-weight: bold;
  color: #000000;
  background-color: #ffffff;
}

.travelPassNumberClass{
  display: flex;

  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */

  margin-left: 6px;
  margin-right: 6px;
  margin-top: 6px;
  margin-bottom: 6px;

  width: 100px;
  height:100px;

  border-top-style: ridge;
  border-right-style: ridge;
  border-left-style: ridge;
  border-bottom-style: ridge;

  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelButtonRowClass{
  display: flex;
  flex-direction: row;
  width:100%;
  height: 40px;
  margin-top: auto;
  margin-bottom: 120px;
  justify-content: center;  /* left/right center */
}

.travelButtonClass {
  display: flex;
  flex-direction: row;
  width: 200px;
  height: 100%;
  margin-left: 20px;
  margin-right: 20px;
  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
  border-radius: 10px;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
  border-bottom-style: solid;

  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelButtonLongClass {
  display: flex;
  flex-direction: row;
  width: 300px;
  height: 100%;
  margin-left: 00px;
  margin-right: 00px;
  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
  border-radius: 10px;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
  border-bottom-style: solid;

  font-size:20px;
  font-weight: bold;
  color: #000000;
}

.travelInputClass{
  display: flex;
  flex-direction: row;
  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
  text-align: center;
  width: 50%;

  font-size:20px;
  outline: none;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: ridge;
  background-color: #ffffff;

  margin-top: 30px;
  margin-left: 25%;

}


/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------  Username Selection  -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.mainPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}


.mainPanelCenterContent{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 90%;
  height: 100%;
}

.contentlogo {
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
}
.content-logo{
  width: 141px;
  height: 40px;
  margin-left: 00px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.header_text{
  font-size:25px;
  margin-top: 20px;
  margin-left: 20px;
  font-weight: bold;
  color: #000000;
  text-align: left;
  padding:0px;
  border: 0;
}
.content_text{
  font-size:20px;
  margin-left: 20px;
  color: #000000;
  text-align: left;
  padding:0px;
  border: 0;
}

.inputstyle
{
  outline: none;
  font-size:20px;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: ridge;
  background-color: #ffffff;
  margin-top: 30px;
  width: 50%;
  margin-left: 5%;
}


.name_input_button
{
  border-radius:20px;
  font-size:20px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  align-items: flex-end;
  align-content: flex-end;
  margin-top: 10px;
  margin-right: 5%;
  width: 100px;
  height: 40px;
  background-color: #13b49b;
}


/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------  Location Selection  -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/


.selectionPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}


.selectionpage{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 90%;
  height: 100%;
}

.mapmap {
  display: flex;
  background-color: #ffffff;
  text-align: justify;
  align-items: center;
  align-content: center;
  width: 70%;
  height: 150px;
  border: 0;
  margin-top: 10px;
  margin-left: 15%;
}

.option_text{
  font-size:19px;
  /* color: #13b49b; */
  color: #575153;
  text-align: left;
  margin-top: 20px;
  border: 0;
  margin-left: 20px;
  padding:0px;
}

.sub_option_text{
  font-size:19px;
  /* color: #BFC9C3; */
  color: #000000;
  text-align: left;
  margin-top: 0px;
  border: 0;
  margin-left: 20px;
  padding:0px;
}



.selectstyle
{
  font-size:20px;
}


.optionbox{
  /*用div的样式代替select的样式*/
  margin-left: 20px;
  width: 300px;
  height: 35px;
  /*border-radius: 5px;*/
  /*盒子阴影修饰作用,自己随意*/
  /* box-shadow: 0 0 5px #ccc;*/
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: ridge;
  background-color: #ffffff;
  position: relative;
}
.optionbox select{
  /*清除select的边框样式*/
  border: none;
  /*清除select聚焦时候的边框颜色*/
  outline: none;
  /*将select的宽高等于div的宽高*/
  width: 100%;
  height: 50px;
  line-height: 40px;
  /*隐藏select的下拉图标*/
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /*通过padding-left的值让文字居中*/
  padding-left: 0px;
}
/*使用伪类给select添加自己想用的图标*/
.optionbox:after{
  content: "";
  width: 16px;
  height: 12px;
  background: url(../assets/vehicle/triangle.png) no-repeat center;
  /*通过定位将图标放在合适的位置*/
  position: absolute;
  right: 11px;
  top: 41%;
  /*给自定义的图标实现点击下来功能*/
  pointer-events: none;
}

.upperfooter {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 40px;
  margin-top: 60px;
  margin-right: auto;
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 40px;
  bottom: 10%;
  position: absolute;
}
.confirmButton {
  width: 40%;
  height: 100%;
  border-radius:20px;
  font-size:20px;
  background-color: #13b49b;
  color: #fff;
  border: none;
  margin-left: auto;
  margin-right: 5%;
}




/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------  Location Selection  -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/


.conclusionPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.conclusionpage{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 90%;
  height: 100%;
}

.completionPanel{
  display: flex;
  flex-direction: column;
  background-color: #13b49b;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.completionpage{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: #13b49b;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 90%;
}

.completiontext {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #13b49b;
  position: relative;
  font-size: 60px;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.mapmapmap {
  display: flex;
  background-color: #ffffff;
  text-align: justify;
  align-items: center;
  align-content: center;
  width: 70%;
  height: 150px;
  border: 0;
  margin-top: 10px;
  margin-left: 15%;
}

.conclusion_text{
  font-size:20px;
  color: #000000;
  text-align: left;
  margin-top: 5px;
  border: 0;
  margin-left: 20px;
  padding:0px;
}

.cancelButton {
  width: 150px;
  height: 100%;
  border-radius:20px;
  font-size:18px;
  background-color: #BFC9C3;
  color: #575153;
  border: none;
  margin-right: auto;
  margin-left: 5%;
}

.finalconfirmButton {
  width: 150px;
  height: 100%;
  border-radius:20px;
  font-size:18px;
  background-color: #13b49b;
  color: #fff;
  border: none;
  margin-left: auto;
  margin-right: 5%;
}

.complete_text_class{
  font-size:20px;
  color: #ffff;
  text-align: center;
  border: 0;
  padding:0px;
}






















.haveOrder {
  display: flex;
  flex-direction: column;
  flex-wrap:wrap-reverse;
  background-color: white;
  margin-left: auto;
  align-items: center;
  align-content: center;
  width: 25%;
  height: 100%;
}

.yesBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #13b49b;
}

.noBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #C7CCD5;
}

.stationButtonOdd
{
  font-size:35px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #13b49b;
}
.stationButtonEven
{
  font-size:35px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #C7CCD5;
}







/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------       Map        -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.maps {
  display: flex;
  background-color: rgba(29, 0, 65, 1);
  text-align: justify;
  width: 100%;
  height: 100%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;

  /*
    flex: 1;
    position: relative;
    overflow: hidden;
    */
}











.main {
  background: linear-gradient(to bottom, #f8f9fc 0%, #f2f7f9 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.2);
  z-index: 999;
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 20px;
  margin-left: 30px;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: right;
}

.time {
  font-weight: 400;
  color: rgba(29, 38, 65, 1);
}

.sign {
  /*
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
   */
  display: flex;
  margin-right: 2%;
}


.speed_block{
  /*
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  display: inline-block;
  position: relative;
}

.speed {
  /*
  width: 50%;
  left: 0%;
  right: 0%;
  text-align: center;
  position: absolute;
  font-weight: bold;
  color: rgba(29, 38, 65, 1);
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  position: absolute;
  text-align: center;
  left: 0%;
  right: 0%;
}
.unit {
/*
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex: 1;
  display: flex;
*/
  position: absolute;
  text-align: right;
  vertical-align: text-bottom;
  top: 30px;
  right: 2%;
}
.line {
  height: 3px;
  width: 100%;
  background: rgba(0, 0, 0, 1);
}


.body {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.stop_logo {
  display: flex;
}
.stopsign_logo {
  display: flex;
}
.car_logo {
  display: flex;
}

.station_block{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.next_station {
  display: flex;
  text-align: center;
}
.station_name {
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_1{
  display: flex;
  text-align: center;
}
.stop_sign_2{
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_3{
  display: flex;
  text-align: center;
}


.start {
  flex: 1;
  /* box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16); */
  color: #fff;
  border: none;
}



.info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #484848;
  position: relative;
}

.electricity {
  height: 20px;
  width: 100px;
}

.split {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}


.block {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.wheel {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.drive {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px;
}

.mask {
  height: 100%;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.canvas {
  height: 100%;
  width: 100%;
}

.msg {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}

.station,
.duration {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.key {
  font-weight: 400;
  color: rgba(128, 132, 143, 1);
  white-space: nowrap;
}

.value {
  font-weight: 400;
  line-height: 49px;
  color: rgba(28, 28, 28, 1);
}

.temp {
  padding: 20px;
  background: rgba(255, 177, 0, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: none;
  margin-right: 10px;
}



@media screen and (min-width: 2048px) {
  .main {
    width: 660px;
    padding: 48px;

    position: absolute;
    margin-top: 50px;
    margin-left: 50px;
    margin-bottom: 50px;

  }

  .time {
    font-size: 44px;
    line-height: 82px;
  }

  .sign {
    height: 120px;
    width: 110px;
  }

  .speed_block {
    height: 250px;
  }

  .speed {
    font-size: 200px;
    line-height: 200px;
  }

  .unit {
    font-size: 30px;
    line-height: 250px;
  }

  .stop_logo {
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    height: 118px;
    width: 114px;
  }
  .next_station {
    font-size: 30px;
    line-height: 100px;
  }
  .station_name {
    font-size: 40px;
    line-height: 150px;
  }
  .stop_sign_1{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_2{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_3{
    font-size: 30px;
    line-height: 100px;
  }


  .start {
    height: 88px;
    font-size: 38px;
    /* border-radius: 88px; */
    border-radius: 0px;
  }



  .block {
    top: -28px;
  }
  .drive {
    height: 600px;
  }

  .key {
    font-size: 28px;
    line-height: 82px;
  }

  .value {
    font-size: 40px;
    line-height: 49px;
  }

  .temp {
    width: 88px;
    height: 88px;
    border-radius: 88px;
  }


}

@media screen and (max-width: 1920px) {
  .main {
    width: 300px;
    height: 95%;
    padding: 30px;
  }


  .speed_block {
    height: 100px;
  }
  .speed {
    font-size: 100px;
    line-height: 100px;
  }
  .unit {
    font-size: 20px;
    line-height: 100px;
  }


  .stop_logo {
    margin-top: 5%;
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    margin-bottom: 10%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    margin-top: 10%;
    height: 124px;
    width: 202px;
  }
  .next_station {
    margin-top: 5%;
    font-size: 20px;
    line-height: 20px;
  }
  .station_name {
    margin-top: 10%;
    font-size: 25px;
    line-height: 25px;
  }
  .stop_sign_1{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_2{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_3{
    font-size: 25px;
    line-height: 30px;
  }



  .start {
    width: 240px;
    height: 50px;
    font-size: 30px;
    /* border-radius: 68px; */
    border-radius: 0px;
  }









  .time {
    font-size: 35px;
    line-height: 64px;
  }

  .sign {
    height: 43px;
    width: 43px;
  }

  .block {
    top: -28px;
  }

  .drive {
    height: 520px;
  }

  .key {
    font-size: 22px;
    line-height: 64px;
  }

  .value {
    font-size: 32px;
    line-height: 30px;
  }

  .temp {
    width: 68px;
    height: 68px;
    border-radius: 68px;
  }

}

picture {
  display: flex;
  align-items: center;
  justify-content: center;
}



.home {
  height: 70px;
  width: 120px;
  position: absolute;
  top: 20px;
  left: 0;
  background: #fff;
  box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.16);
  border-radius: 0 88px 88px 0;
  z-index: 9989;
  display: flex;
  align-items: center;
  justify-content: center;
}


.log,
.phone,
.close {
  position: absolute;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  border-radius: 44px 0px 0px 44px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}


.logo {
  top: 20px;
  right: 0;
  width: 220px;
}



.log {
  height: 100px;
  width: 100px;
  bottom: 280px;
  right: 38px;
  border-radius: 50%;
}

.phone {
  height: 100px;
  width: 100px;
  bottom: 160px;
  right: 38px;
  border-radius: 50%;
}

.close {
  height: 100px;
  width: 100px;
  bottom: 40px;
  right: 38px;
  border-radius: 50%;
}

.shut {
  height: 80px;
  font-family: PingFang-SC-Bold;
  font-size: 40px;
  color: #1c1c1c;
  text-align: center;
  line-height: 40px;
}
</style>
